import { useEffect } from 'react';
import { trackEventAtKeyPath } from 'srcAlias/client/analytics';
import { store } from 'srcAlias/initialization';
import { get } from 'lodash-es';
import { useSelector } from 'react-redux';
import {
  selectApplicationId,
  selectProductDetails,
  selectSessionId,
} from 'srcAlias/client/state/selectors';

export const trackEventAnalytics = (type, name, data) => {
  trackEventAtKeyPath({
    type,
    name,
    keyPath: name,
    state: data,
  });
};

export const callTrackEventAnalyticsFunction = (type, name, formValues) => {
  const reduxState = store.getState();
  const applicationId = get(
    reduxState,
    'eligibility.responseData.data.applicationId',
    ''
  );
  const sessionId = get(reduxState, 'sessionId', '');
  const productSelection = get(reduxState, 'productSelection', '');

  if (!(formValues && formValues !== {})) {
    return get(reduxState, 'formValues', {});
  }
  return trackEventAnalytics(type, name, {
    application: {
      applicationId,
    },
    productSelection,
    sessionId,
    formValues: {
      ...formValues,
    },
  });
};

export const useTrackEventAnalyticsHook = (type, name, formValues = {}) => {
  const applicationId = useSelector(selectApplicationId);
  const sessionId = useSelector(selectSessionId);
  const productSelection = useSelector(selectProductDetails);

  useEffect(() => {
    trackEventAnalytics(type, name, {
      application: {
        applicationId,
      },
      productSelection,
      sessionId,
      formValues: {
        ...formValues,
      },
    });
  }, []);
};

export const useTrackEventAnalyticsFromReducer = (
  type,
  name,
  formValues,
  state
) => {
  const applicationId = get(
    state,
    'eligibility.responseData.data.applicationId',
    ''
  );
  const sessionId = get(state, 'sessionId', '');
  const productSelection = get(state, 'productSelection', '');

  if (!(formValues && formValues !== {})) {
    return get(state, 'formValues', {});
  }

  return trackEventAnalytics(type, name, {
    application: {
      applicationId,
    },
    productSelection,
    sessionId,
    formValues: {
      ...formValues,
    },
  });
};

export default useTrackEventAnalyticsHook;
